import type { LatLng, LatLngBounds } from 'leaflet';

import * as actions from './actions';
import { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

export interface IStopHighlightingFeature {
  stopHighlighting(): IStopHighlightingFeature
}

export interface IHighlightFeature {
  highlight(features: FeatureWithIDs<unknown>): void
}

export type PlainGeometryJSON = Record<string, unknown> & { type: string };

type MapState = {
  zoom: number | undefined;
  center: LatLng | undefined;
  bounds: LatLngBounds | undefined;
  backgroundMapReady: 'READY' | 'NOT_READY';
  initialExtent: PlainGeometryJSON | undefined,
  view?: IStopHighlightingFeature & IHighlightFeature,
};

const state: MapState = {
  zoom: undefined,
  center: undefined,
  bounds: undefined,
  backgroundMapReady: 'NOT_READY',
  initialExtent: undefined,
  view: undefined,
};

export { state, actions };
